import { Routes } from '@angular/router';
import { TurnosPage } from './pages/turnos.page/turnos.page';

export const routes: Routes = [
  {
    path: '',
    component: TurnosPage
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin.page/admin.page').then(m => m.AdminPage)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login.page/login.page').then(m => m.LoginPage)
  },
  {
    path: 'v2',
    loadComponent: () => import('./pages/v2/monitor-v2.page/monitor-v2.page').then(m => m.MonitorV2Page)
  },
  {
    path: '**',
    redirectTo: 'v2',
    pathMatch: 'full'
  }
];
